var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('form',{ref:"stripeElement",staticClass:"form-input-group payment-method",attrs:{"id":"stripe-payment-element"},on:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }